import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  parentsList: {
    data: [],
    total: 0,
  },
};

const parentsSlice = createSlice({
  name: "parents",
  initialState,
  reducers: {
    setParentsList: (state, action) => {
      state.parentsList = action.payload;
    },
  },
});

export const { setParentsList } = parentsSlice.actions;
export default parentsSlice.reducer;